import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection1, TestimonialsSection2 } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { CountdownTimer } from './components/CountdownTimer';
import { Button } from './components/Button';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '735822559325172');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans pb-16 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialsSection1 data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PurchaseSection data-id="element-7" />
      <TestimonialsSection2 data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Final CTA Section */}
      <section className="py-6 md:py-10 px-4 bg-brand-card border-t border-white/5" data-id="element-11">
        <div className="max-w-3xl mx-auto text-center" data-id="element-12">
          <h2 className="text-lg md:text-2xl font-black text-white mb-2 uppercase tracking-tight leading-tight" data-id="element-13">
            🏋️ El próximo fin de semana podés seguir buscando ejercicios...
          </h2>
          <p className="text-base md:text-xl font-black text-brand-accent neon-glow mb-4 uppercase" data-id="element-14">
            O podés tener todo resuelto desde hoy.
          </p>
          <p className="text-xs text-gray-400 font-medium max-w-xl mx-auto mb-6" data-id="element-15">
            Argentina, México, Colombia, Chile, Perú, Guatemala, Venezuela o
            cualquier rincón de LATAM. El problema es el mismo.{' '}
            <span className="text-white font-bold" data-id="element-16">La solución también.</span>
          </p>

          {/* Red urgency strip */}
          <div className="bg-red-600 rounded-xl py-3 px-4 mb-6 border border-red-400" data-id="element-17">
            <p className="text-white font-black text-xs uppercase tracking-widest mb-2 animate-pulse" data-id="element-18">
              ⏰ El precio de lanzamiento cierra en:
            </p>
            <CountdownTimer className="!text-white [&_div]:!border-white/30 [&_div]:!bg-red-700 [&_span]:!text-white/60 !text-lg" data-id="element-19" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto mb-6" data-id="element-20">
            {/* Premium */}
            <div className="bg-brand-dark rounded-xl border-2 border-brand-accent p-4 flex flex-col relative shadow-[0_0_20px_rgba(200,255,0,0.15)]" data-id="element-21">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-black px-3 py-0.5 rounded-full text-[10px] tracking-widest shadow-lg whitespace-nowrap uppercase" data-id="element-22">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="text-sm font-black text-white mb-1 mt-1" data-id="element-23">
                🏆 KIT + SISTEMA PRO
              </h3>
              <p className="text-brand-accent font-bold text-[10px] mb-2" data-id="element-24">
                6 tomos + 180 clases + Programación + 4 bonos
              </p>
              <div className="flex items-center justify-center gap-2 mb-3 flex-grow" data-id="element-25">
                <span className="text-xs text-gray-500 line-through font-bold" data-id="element-26">
                  USD 45
                </span>
                <span className="text-2xl font-black text-brand-accent neon-glow" data-id="element-27">
                  USD 19.90
                </span>
              </div>
              <Button href="https://kit-online-2026.myshopify.com/cart/44498607440007:1" className="py-2.5 text-xs" pulse={true} data-id="element-28">
                → QUIERO MI KIT COMPLETO
              </Button>
            </div>
            {/* Basic */}
            <div className="bg-brand-dark rounded-xl border border-white/10 p-4 flex flex-col relative" data-id="element-29">
              <h3 className="text-sm font-black text-white mb-1 mt-1" data-id="element-30">
                📘 KIT FUNCIONAL LISTO
              </h3>
              <p className="text-gray-400 font-bold text-[10px] mb-2" data-id="element-31">
                6 Tomos + 60 clases principiantes + 4 bonos
              </p>
              <div className="flex items-center justify-center gap-2 mb-3 flex-grow" data-id="element-32">
                <span className="text-xs text-gray-500 line-through font-bold" data-id="element-33">
                  USD 35
                </span>
                <span className="text-2xl font-black text-white" data-id="element-34">
                  USD 13.99
                </span>
              </div>
              <Button href="https://kit-online-2026.myshopify.com/cart/44498607341703:1" className="py-2.5 text-xs" pulse={false} data-id="element-35">
                → QUIERO EL KIT BASE
              </Button>
            </div>
          </div>

          <p className="text-[10px] md:text-xs text-gray-400 font-medium mb-3 leading-snug max-w-lg mx-auto" data-id="element-36">
            El precio es en dólares estadounidenses (USD). El cobro se realiza
            automáticamente en la moneda de tu país al tipo de cambio del
            momento. Pagas en pesos mexicanos, euros, pesos colombianos, soles
            peruanos, pesos chilenos, bolívares, quetzales, lempiras, colones,
            balboas, córdobas o cualquier otra moneda local según su país de
            origen.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-[10px] text-gray-400 font-bold uppercase tracking-wide" data-id="element-37">
            <div className="flex items-center" data-id="element-38">
              <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-39" />
              <span data-id="element-40">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-41">
              <Zap className="w-3 h-3 mr-1 text-brand-accent" data-id="element-42" />
              <span data-id="element-43">Acceso 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-44">
              <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-45" />
              <span data-id="element-46">Garantía 7 días</span>
            </div>
            <div className="flex items-center" data-id="element-47">
              <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-48" />
              <span data-id="element-49">Tarjeta · Transferencia · Pago local</span>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-50" />
      <SocialProofPopup data-id="element-51" />
      <StickyMobileCTA data-id="element-52" />

      <noscript data-id="element-53">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=735822559325172&ev=PageView&noscript=1" alt="" data-id="element-54" />
      </noscript>
    </div>;
}